import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import PeriodeEvaluation from './periode-evaluation';
import PeriodeEvaluationDetail from './periode-evaluation-detail';
import PeriodeEvaluationUpdate from './periode-evaluation-update';
import PeriodeEvaluationDeleteDialog from './periode-evaluation-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId`} component={PeriodeEvaluation} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId/new`} component={PeriodeEvaluationUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId/:id/edit`} component={PeriodeEvaluationUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId/:id`} component={PeriodeEvaluationDetail} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid`} component={PeriodeEvaluation} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/new`} component={PeriodeEvaluationUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:id/edit`} component={PeriodeEvaluationUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:id`} component={PeriodeEvaluationDetail} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId/:id/delete`} component={PeriodeEvaluationDeleteDialog} />
    <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:id/delete`} component={PeriodeEvaluationDeleteDialog} />
  </>
);

export default Routes;
